export default "__VITE_ASSET__qQGcpKDs__"